<div google-chart chart="wctrl.chartCfg" ng-style="wctrl.chartStyle" ng-if="!wctrl.empty && !wctrl.loading && !wctrl.error"></div>
<p class="history-day text-cinza text-center" ng-show="wctrl.loading">
  <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
</p>
<div class="alert alert-info" ng-if="wctrl.empty">
  <p>Não há dados para serem exibidos.</p>
</div>
<div class="alert alert-danger" ng-if="wctrl.error">
  <p>Falha ao obter dados.</p>
</div>
